import React from 'react';
import dayjs from 'dayjs';
import type { ReactElement } from 'react';

import { downloadAsFile } from '@utils';

interface MakeExtendErrorInterface {
  status?: string | number;
  error?: string | number;
  trace?: string;
}

export const makeExtendError = ({ status, error, trace }: MakeExtendErrorInterface): ReactElement => {
  const downloadErrorTrace = () => {
    const blob = new Blob([trace ?? ''], { type: 'text/plain' });
    const date = dayjs(new Date()).format();
    downloadAsFile(blob, `trace-${date}.txt`, 'text/plain');
  };
  return (
    <div>
      Ошибка обработки данных
      <br />
      Статус: {status}
      <br />
      Ошибка: {error}
      {trace && (
        <>
          <br />
          <a href="#" onClick={downloadErrorTrace}>
            Скачать трассировку
          </a>
        </>
      )}
    </div>
  );
};
